import { useThemeContext } from "../../context/ThemeContext";
import { content } from "../../data/content";

import { StackCard } from "../Card/StackCard/StackCard";

import styles from "./Stack.module.scss";

interface StackProps {
  card?: boolean;
}

export function Stack({ card }: StackProps) {
  const theme = useThemeContext();
  const c = content;
  const stackChips = c.stack.map((chip) => ({
    label: chip.replace(/\s*\*/, ""),
    inProgress: chip.includes("*"),
  }));

  return card ? (
    <StackCard label="stack" labelType="free" stack={c.stack} />
  ) : (
    <div className={styles.stack}>
      {stackChips.map((chip, i) => (
        <span
          key={i}
          className={styles.stackChip}
          style={{
            border: `1px solid ${theme.rule}`,
            color: chip.inProgress ? theme.acc : theme.muted,
            background: chip.inProgress
              ? `${theme.acc}14`
              : theme.dark
                ? "rgba(255,255,255,0.03)"
                : "rgba(255,255,255,0.5)",
          }}
        >
          {chip.label}
        </span>
      ))}
    </div>
  );
}
